const allAirlines = [
  { name: "aeroflot", path: "./airlinesInfoJsons/aeroflot.json", partner: true },
  { name: "uzairways", path: "./airlinesInfoJsons/uzairways.json", partner: true },
  { name: "turkishAirlines", path: "./airlinesInfoJsons/turkishAirlines.json", partner: true },
  { name: "belavia", path: "./airlinesInfoJsons/belavia.json", partner: true },
  { name: "uralAirlines", path: "./airlinesInfoJsons/uralAirlines.json", partner: true },
  { name: "s7", path: "./airlinesInfoJsons/s7.json", partner: true },
  { name: "qanotsharq", path: "./airlinesInfoJsons/qanotsharq.json", partner: true },
  { name: "pobeda", path: "./airlinesInfoJsons/pobeda.json", partner: true },
  { name: "airastana", path: "./airlinesInfoJsons/airastana.json", partner: true },
  { name: "flyaristan", path: "./airlinesInfoJsons/flyaristan.json", partner: true },
  { name: "aircairo", path: "./airlinesInfoJsons/aircairo.json", partner: false },
  { name: "airchina", path: "./airlinesInfoJsons/airchina.json", partner: false },
  { name: "airmanas", path: "./airlinesInfoJsons/airmanas.json", partner: false },
  { name: "asianaAirlines", path: "./airlinesInfoJsons/asianaAirlines.json", partner: false },
  { name: "aviaTraffic", path: "./airlinesInfoJsons/aviaTraffic.json", partner: false },
  { name: "azal", path: "./airlinesInfoJsons/azal.json", partner: false },
  { name: "azimuth", path: "./airlinesInfoJsons/azimuth.json", partner: false },
  { name: "azurair", path: "./airlinesInfoJsons/azurair.json", partner: false },
  { name: "spicejet", path: "./airlinesInfoJsons/spicejet.json", partner: false },
  { name: "iraero", path: "./airlinesInfoJsons/iraero.json", partner: false },
  { name: "rossiyaAirlines", path: "./airlinesInfoJsons/rossiyaAirlines.json", partner: false },
  { name: "yakutiaAirlines", path: "./airlinesInfoJsons/yakutiaAirlines.json", partner: false },
  { name: "yamalAirlines", path: "./airlinesInfoJsons/yamalAirlines.json", partner: false },
  { name: "nordwindAir", path: "./airlinesInfoJsons/nordwindAir.json", partner: false },
  { name: "lufthansaAir", path: "./airlinesInfoJsons/lufthansaAir.json", partner: false },
  { name: "silkAvia", path: "./airlinesInfoJsons/silkAvia.json", partner: false },
  { name: "tajikAir", path: "./airlinesInfoJsons/tajikAir.json", partner: false },
  { name: "somonAir", path: "./airlinesInfoJsons/somonAir.json", partner: false },
  { name: "kamAir", path: "./airlinesInfoJsons/kamAir.json", partner: false },
  { name: "ikarAir", path: "./airlinesInfoJsons/ikarAir.json", partner: false },
  { name: "flydubai", path: "./airlinesInfoJsons/flydubai.json", partner: false },
  { name: "kuwaitAirways", path: "./airlinesInfoJsons/kuwaitAirways.json", partner: false },
  { name: "emiratesAir", path: "./airlinesInfoJsons/emiratesAir.json", partner: false },
  { name: "centrumAir", path: "./airlinesInfoJsons/centrumAir.json", partner: false },
  { name: "egyptAir", path: "./airlinesInfoJsons/egyptAir.json", partner: false },
  { name: "chinaSouthern", path: "./airlinesInfoJsons/chinaSouthern.json", partner: false },
  { name: "pia", path: "./airlinesInfoJsons/pia.json", partner: false },
  { name: "airblue", path: "./airlinesInfoJsons/airblue.json", partner: false },
  { name: "sereneAir", path: "./airlinesInfoJsons/sereneAir.json", partner: false },
  { name: "airIndia", path: "./airlinesInfoJsons/airIndia.json", partner: false },
  { name: "vistara", path: "./airlinesInfoJsons/vistara.json", partner: false },
  { name: "gulfAir", path: "./airlinesInfoJsons/gulfAir.json", partner: false },
  { name: "omanAir", path: "./airlinesInfoJsons/omanAir.json", partner: false },
  { name: "salamAir", path: "./airlinesInfoJsons/salamAir.json", partner: false },
  { name: "iranAsemanAirlines", path: "./airlinesInfoJsons/iranAsemanAirlines.json", partner: false },
  { name: "kishAir", path: "./airlinesInfoJsons/kishAir.json", partner: false },
  { name: "qeshmAir", path: "./airlinesInfoJsons/qeshmAir.json", partner: false },
  { name: "syrianAir", path: "./airlinesInfoJsons/syrianAir.json", partner: false },
  { name: "middleEastAirlines", path: "./airlinesInfoJsons/middleEastAirlines.json", partner: false },
  { name: "aircompanyArmenia", path: "./airlinesInfoJsons/aircompanyArmenia.json", partner: false },
  { name: "arianaAfghanAirlines", path: "./airlinesInfoJsons/arianaAfghanAirlines.json", partner: false },
  { name: "georgianAirways", path: "./airlinesInfoJsons/georgianAirways.json", partner: false },
  { name: "myWayAirlines", path: "./airlinesInfoJsons/myWayAirlines.json", partner: false },
  { name: "koreanAir", path: "./airlinesInfoJsons/koreanAir.json", partner: false },
  { name: "jazeeraAirways", path: "./airlinesInfoJsons/jazeeraAirways.json", partner: false },
  { name: "mahanAir", path: "./airlinesInfoJsons/mahanAir.json", partner: false },
  { name: "indigoAirlines", path: "./airlinesInfoJsons/indigoAirlines.json", partner: false },
  { name: "alrosaAirlines", path: "./airlinesInfoJsons/alrosaAirlines.json", partner: false },
  { name: "turkmenistanAirlines", path: "./airlinesInfoJsons/turkmenistanAirlines.json", partner: false },
  { name: "saudiaAirlines", path: "./airlinesInfoJsons/saudiaAirlines.json", partner: false },
  { name: "pegasusAir", path: "./airlinesInfoJsons/pegasusAir.json", partner: false },
  { name: "wizzAir", path: "./airlinesInfoJsons/wizzAir.json", partner: false },
];

export const getAllAirlines = async () => {
  const airlines = [];

  for (let i = 0; i < allAirlines.length; i++) {
    const airlineData = await import(`${allAirlines[i].path}`);

    if (!!airlineData?.default) {
      airlines.push(airlineData);
    }
  }

  return airlines;
};

export const getAirlinesMiniInfo = async (limit, isRandomSort = true) => {
  let limitedAndSortedAirlines = [...allAirlines];

  if (isRandomSort) {
    limitedAndSortedAirlines.sort(() => Math.random() - 0.5);
  }

  if (limit > 0) {
    limitedAndSortedAirlines = limitedAndSortedAirlines.slice(0, limit);
  }

  const result = [];

  for (let i = 0; i < limitedAndSortedAirlines.length; i++) {
    const airlineData = await import(`${limitedAndSortedAirlines[i].path}`);

    if (!!airlineData?.default) {
      result.push({
        key: airlineData.default.key,
        partner: airlineData.default.partner,
        name: airlineData.default.name,
        imageUrl: airlineData.default.imageUrl,
        smImageUrl: airlineData.default.smImageUrl,
      });
    }
  }

  return result;
};

export const getPartnersMiniInfo = async limit => {
  const limitedAndFilteredAirlines = allAirlines.filter(airline => airline.partner === true);

  if (limit > 0) {
    limitedAndFilteredAirlines.slice(0, limit);
  }

  const result = [];

  for (let i = 0; i < limitedAndFilteredAirlines.length; i++) {
    const airlineData = await import(`${limitedAndFilteredAirlines[i].path}`);

    if (!!airlineData?.default) {
      result.push({
        key: airlineData.default.key,
        partner: true,
        name: airlineData.default.name,
        imageUrl: airlineData.default.imageUrl,
        smImageUrl: airlineData.default.smImageUrl,
      });
    }
  }

  return result;
};
